<template>
  <div ref="temporary">
    <content-row class="justify-between !gap-1">
      <slot />
      <TButtonGroup>
        <TGroupButton
          :active="!detailOpen"
          data-testid="collapse-button"
          @click="detailOpen = false"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 3V17V19H3H17H19V17V3V1H17H3H1V3ZM17 3H3V17H17V3Z"
              fill="currentColor"
            />
          </svg>
        </TGroupButton>
        <TGroupButton
          :active="detailOpen"
          data-testid="expand-button"
          @click="detailOpen = true"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.59375 3.625C7.94922 3.625 8.25 3.92578 8.25 4.28125C8.25 4.66406 7.94922 4.9375 7.59375 4.9375H5.1875V7.34375C5.1875 7.72656 4.88672 8 4.53125 8C4.14844 8 3.875 7.72656 3.875 7.34375V4.28125C3.875 3.92578 4.14844 3.625 4.53125 3.625H7.59375ZM15.4688 3.625C15.8242 3.625 16.125 3.92578 16.125 4.28125V7.34375C16.125 7.72656 15.8242 8 15.4688 8C15.0859 8 14.8125 7.72656 14.8125 7.34375V4.9375H12.4062C12.0234 4.9375 11.75 4.66406 11.75 4.28125C11.75 3.92578 12.0234 3.625 12.4062 3.625H15.4688ZM7.59375 14.5625C7.94922 14.5625 8.25 14.8633 8.25 15.2188C8.25 15.6016 7.94922 15.875 7.59375 15.875H4.53125C4.14844 15.875 3.875 15.6016 3.875 15.2188V12.1562C3.875 11.8008 4.14844 11.5 4.53125 11.5C4.88672 11.5 5.1875 11.8008 5.1875 12.1562V14.5625H7.59375ZM15.4688 11.5C15.8242 11.5 16.125 11.8008 16.125 12.1562V15.2188C16.125 15.6016 15.8242 15.875 15.4688 15.875H12.4062C12.0234 15.875 11.75 15.6016 11.75 15.2188C11.75 14.8633 12.0234 14.5625 12.4062 14.5625H14.8125V12.1562C14.8125 11.8008 15.0859 11.5 15.4688 11.5Z"
              fill="currentColor"
            />
          </svg>
        </TGroupButton>
      </TButtonGroup>
    </content-row>
    <transition name="slide-fade" mode="out-in">
      <div v-if="detailOpen" key="expanded">
        <slot name="independent-to-expand" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
  import { TButtonGroup, TGroupButton } from "@topol/twig-ui";
  import { ref, onMounted } from "vue";

  const props = defineProps({
    header: {
      type: String,
      default: "",
    },
    borderBottom: {
      type: Boolean,
      default: true,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    borderFull: {
      type: Boolean,
      default: false,
    },
    chip: {
      type: String,
      default: "",
    },
    chipSecondary: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 12,
    },
    marginBottom: {
      type: Number,
      default: 20,
    },
    headerMarginBottom: {
      type: Number,
      default: 8,
    },
    paddingLeftRight: {
      type: Number,
      default: 10,
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    toggleLabel: {
      type: String,
      default: "",
    },
    changed: {
      type: Boolean,
      default: false,
    },
  });

  const adjustedMarginTop = ref(props.marginTop);
  const adjustedHeaderMarginBottom = ref(props.headerMarginBottom);
  // Only the initial value matters: the detail auto-expands on load when the
  // value is "Mixed", but the user's manual open/close is respected while
  // editing (we intentionally do NOT react to later defaultOpen changes).
  const detailOpen = ref(props.defaultOpen);

  onMounted(() => {
    if (document.querySelectorAll(".mini").length > 0) {
      adjustedMarginTop.value -= 4;
      adjustedHeaderMarginBottom.value -= 4;
    }
  });
</script>
<style lang="scss"></style>
